import { FamilyService } from '@app/services/family/family.service';
import { localStorageService } from './../../../services/localStorage/localStorage.service';
import { Subscription } from 'rxjs';
import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';
import { OrdersService } from '@app/services/order/orders.service';
import { PdvService } from '@app/services/pdv/pdv.service';
import { AuthService } from '@app/modules/angular-6-social-login-master';


@Component({
    selector: 'top-navig',
    templateUrl: 'top-navig.component.html',
    styleUrls: ['top-navig.component.scss'],
    providers:[AuthService]
})

export class TopNavigComponent {
    @ViewChild("template1")
    template;
    ourApp = false;
    @Input()
    transp = false;
    @Input()
    b_bottom = false;
    @Input()
    transparent = false;
    @Input()
    display = false;
    @Input()
    displaySing = false;
    @Input()
    displayLogo = false;
    @Input()
    title: string = '';
    @Input()
    displayFilter = false;
    @Input()
    displayFam = false;
    @Output()
    openFilterEv: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    openFilterFamEv: EventEmitter<boolean> = new EventEmitter<boolean>();
    bsModalRef: BsModalRef;
    modalRef: BsModalRef;
    modalRef1: BsModalRef;
    log: boolean = false;
    customerName: string = '';
    order: any = { elementsNbr: 0 };
    elementsNbr: number = 0;
    elementsNbrOrg: number = 0;
    subscriptions: any[] = [];
    animation: boolean = false;
    isNapoli: boolean = true;
    toFamilies = false;
    displayBestSales = true;
    orderTypLabel: string;
    title1: string = '';
    date = new Date();
    logoutaction=false;
    constructor(
        private router: Router,
        private modalService: BsModalService,
        private webSiteUsersService: WebSiteUsersService,
        private orderService: OrdersService,
        private pdvService: PdvService,
        private familyService: FamilyService,
        private localStorageService:localStorageService,
        private OAuth: AuthService
    ) {
        const subs = this.orderService.elementsNbr.subscribe(elementsNbr => {
            setTimeout(() => {
                if (elementsNbr > this.elementsNbr) {
                    this.animation = true;
                    this.elementsNbr = elementsNbr;
                }
                setTimeout(() => {
                    this.animation = false;
                }, 500)
            }, 500)
        });

        const subs1 = this.webSiteUsersService.listener.subscribe(
            log => {
                this.log = log
            }
        )

        this.pdvService.pdv.subscribe(
            (pdv: any) => {
                if (pdv) {
                    this.displayBestSales = pdv.displayBestSales;
                }
            }
        )
        this.orderService.ourAppEvent.subscribe(
            data => {
                this.ourApp = data;
            }
        )
        this.subscriptions.push(subs, subs1);
    }

    ngOnInit() {
        if (this.title == 'Carte') {
            this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
                this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
                    if (orderTypes.length >= 1 && chosenOrderType > 0) {
                        this.title1 = orderTypes.filter(o => o.id == chosenOrderType)[0].label
                    }
                });
            });
        } else {
            this.title1 = this.title;
        }
    }

    changeMode() {
        if (this.elementsNbr > 0) {
            this.logoutaction=false;
            this.modalRef1 = this.modalService.show(this.template, {
                class: "ordertype-modal"
            });
        } else {
            this.router.navigate(['modes'])
        }
    }


    activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) == 0 && this.router.url.indexOf(routename + '/') == -1;
    }


    logout() {
        this.logoutaction=true;
        this.modalRef1 = this.modalService.show(this.template, {
            class: "ordertype-modal"
        });
    }

    confirm() {
        if(this.logoutaction){
            this.OAuth.signOut().then()
            this.localStorageService.clear();
            this.log=false;
            this.webSiteUsersService.listener.next(false);
            this.router.navigate(['/']);
        }else{
            this.orderService.clearOrder();
            this.router.navigate(['/modes']);
        }
        if (this.modalRef1) {
            this.modalRef1.hide();
        }
        if (this.modalRef) {
            this.modalRef.hide();
        }
    }

    toDirection() {
        if (this.displayBestSales) {
            this.router.navigate(['/carte/top-des-ventes'])
        } else {
            this.familyService.families.subscribe(
                (families: any[]) => {
                    this.router.navigate(['/carte/famille/' + families[0].slug])
                }
            )
        }
        this.modalRef.hide();

    }

    decline() {
        this.modalRef1.hide();
    }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template, { class: 'sidemenu' });
    }

    openFilter() {
        this.openFilterEv.emit(true);
    }
    openFilterFam() {
        this.openFilterFamEv.emit(true);
    }

    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    ngOnDestroy() {
        this.unsubscribe();
    }
}
